import React from 'react';
import { Field } from 'redux-form';
import { Button, Form, Icon, Grid, Accordion } from 'semantic-ui-react';
import PropTypes from 'prop-types';

import { SelectField } from 'Common/SemanticWrapper';
import {
  onHandTimeOptions,
  sortByOptions,
  warehouseHoldGroupByOptions,
} from '../helper';
import { WarehouseReportEnum } from 'Common/FieldEnum';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { WAREHOUSE_KITCHEN_HOLD_FORM_NAME } from 'Common/FormEnum';
import { SiteComponent } from 'Common/SiteComponent';
import { SiteTypeEnum } from 'Common/Constants/Enumeration/SiteTypeEnum';

const WarehouseHoldComponent = props => {
  const { activeIndexes, handleCollapsePanelClick, clearFilters } = props;
  return (
    <Form>
      <Grid>
        <Grid.Row>
          <Grid.Column width={4} className="pl-0">
            <SiteComponent
              name={WarehouseReportEnum.WarehouseKitchen}
              label={'Warehouse/Kitchen'}
              onChange={this.dropDownChange}
              isForm={true}
              siteMasterTypeIds={[SiteTypeEnum.Warehouse, SiteTypeEnum.Kitchen]}
              style={{ marginBottom: 10 }}
              isAllRequired={true}
              checkIsLicensed={false}
              isAllValueZero={true}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Accordion fluid styled>
            <Accordion.Title
              active={activeIndexes.indexOf(0) !== -1}
              index={0}
              onClick={handleCollapsePanelClick}
            >
              <Icon name="dropdown" />
              <span className="text-orange">Filter By</span>
            </Accordion.Title>
            <Accordion.Content active={activeIndexes.indexOf(0) !== -1}>
              <Grid>
                <Grid.Row>
                  <Grid.Column width={4}>
                    <Field
                      component={SelectField}
                      label={'On Hold Time'}
                      name={WarehouseReportEnum.OnHoldTime}
                      options={onHandTimeOptions}
                    />
                  </Grid.Column>
                  <Grid.Column width={12} verticalAlign={'bottom'}>
                    <Button
                      type="button"
                      content="Clear Filters"
                      className="clear-filter"
                      onClick={clearFilters}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Accordion.Content>
            <Accordion.Title
              active={activeIndexes.indexOf(1) !== -1}
              index={1}
              onClick={handleCollapsePanelClick}
            >
              <Icon name="dropdown" />
              <span className="text-orange">Sort By</span>
            </Accordion.Title>
            <Accordion.Content active={activeIndexes.indexOf(1) !== -1}>
              <Grid>
                <Grid.Row columns={3} className={'pt10'}>
                  <Grid.Column width={13} verticalAlign={'bottom'}>
                    <ReduxFormButtonGroup
                      options={sortByOptions}
                      formName={WAREHOUSE_KITCHEN_HOLD_FORM_NAME}
                      fieldName={WarehouseReportEnum.SortBy}
                      type={'button'}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Accordion.Content>
            <Accordion.Title
              active={activeIndexes.indexOf(2) !== -1}
              index={2}
              onClick={handleCollapsePanelClick}
            >
              <Icon name="dropdown" />
              <span className="text-orange">Group By</span>
            </Accordion.Title>
            <Accordion.Content active={activeIndexes.indexOf(2) !== -1}>
              <Grid>
                <Grid.Row columns={3} className={'pt10'}>
                  <Grid.Column width={13} verticalAlign={'bottom'}>
                    <ReduxFormButtonGroup
                      options={warehouseHoldGroupByOptions}
                      formName={WAREHOUSE_KITCHEN_HOLD_FORM_NAME}
                      fieldName={WarehouseReportEnum.GroupBy}
                      type={'button'}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Accordion.Content>
          </Accordion>
        </Grid.Row>
      </Grid>
    </Form>
  );
};
WarehouseHoldComponent.propTypes = {
  activeIndexes: PropTypes.array,
  clearFilters: PropTypes.func,
  handleCollapsePanelClick: PropTypes.func,
};

WarehouseHoldComponent.defaultProps = {
  activeIndexes: [],
  clearFilters: () => {},
  handleCollapsePanelClick: () => {},
};

export default WarehouseHoldComponent;



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/warehousereport/components/WarehouseHold.js